import React from "react";
import { commaSeperated, displayUnit } from "../../utils/functions";

const MonthwiseWealth = ({
  period,
  actualAmount,
  amount,
  unit,
  percentage,
  isNegative,
  width,
  isAmtNegative,
}) => {
  return (
    <div className="contaier1" style={{ width: width }}>
      <div className="sub_title1">
        <div className="title1">{`${period}`}</div>
      </div>
      <div className="sub_main_data1">
        {isNegative ? (
          <>
            <div className="sub_data1">
              <span className="amt">
                {amount && amount !== "-" ? commaSeperated(amount) : "-"}
              </span>
              <span className="unit"> {displayUnit(unit)}</span>
            </div>
            <div className="sub_data2">
              <span className="perc">
                {percentage && percentage !== "-"
                  ? commaSeperated(percentage) + "%"
                  : percentage}{" "}
              </span>
            </div>
          </>
        ) : (
          <>
            <div className="sub_data1">
              {amount && amount !== "-" ? (
                <>
                  <span className="amt_green">
                    {"+" + commaSeperated(amount)}
                  </span>
                  <span className="unit_green"> {displayUnit(unit)}</span>
                </>
              ) : (
                <span>-</span>
              )}
            </div>
            <div className="sub_data2">
              {percentage && percentage !== "-" ? (
                <span className="perc_green">
                  {" "}
                  {"+" + commaSeperated(percentage) + "%"}
                </span>
              ) : (
                <span>-</span>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MonthwiseWealth;
